export default __webpack_public_path__ + "a9b2db3efcb3645e9a89531bc6461a7b.svg";